/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const NotificationFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M22 20H2v-2h1v-6.97A9 9 0 0 1 12 2c4.97 0 9 4.04 9 9.03V18h1zM9.5 21h5a2.5 2.5 0 0 1-5 0" />
  </Icon>
);
